import { z } from 'zod';

import { EscrowPaymentHistoryItemId, LosId, PaymentId, QcDocumentId } from '../../BrandedIds';
import { Actor } from '../../events/BaseLoanEvent';
import { EscrowPaymentHistoryItemStatus } from '../../loan/EscrowPaymentHistoryItem';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableEscrowPaymentHistoryItem = z
  .object({
    id: EscrowPaymentHistoryItemId,
    loanId: LosId,

    type: z.enum(['initial', 'manualUpdate', 'shortagePayment', 'analysis', 'constructionToPermanent']),
    createdAt: zodTemporalInstant,
    newMonthlyAmount: z.number(),
    actor: Actor,
    status: EscrowPaymentHistoryItemStatus.optional(),

    effectiveDate: zodTemporalPlainDate.optional(),
    escrowShortageAnalysisId: EscrowPaymentHistoryItemId.optional(),
    paymentId: PaymentId.optional(),
    shortageAmount: z.number().optional(),
    newMonthlyAmountIfShortagePaidUpfront: z.number().optional(),
    qcDocumentId: QcDocumentId.optional(),
  })
  .meta({ title: 'EscrowPaymentHistoryItem' });

export type ExportableEscrowPaymentHistoryItem = z.infer<typeof ExportableEscrowPaymentHistoryItem>;
